import { useMutation } from '@tanstack/vue-query';
import { getApi } from '../api';

export default () => useMutation({
    mutationFn: ({ accountId, formData }: { accountId: number; formData: FormData }) => {
        const { api, baseURL } = getApi();
        return api.post(`/api/v2/accounts/${accountId}/map-overlays`, formData, {
            baseURL,
        }).then(res => res.data.data);
    },
});
